import React from 'react';
import PropTypes from 'prop-types';

import TypeAheadFilter from '../design/shared/filter/typeAheadFilter';
import { Box } from '../design/css';

const TypeAheadFilters = ({ filters }) => {
  return filters.map(filter => {
    const { label, placeholder, options, selected, onChange } = filter;

    return (
      <Box key={label} width={30} mdWidth={100} pb={24}>
        <TypeAheadFilter
          label={label}
          placeholder={placeholder}
          options={options}
          selected={selected}
          onChange={onChange}
        />
      </Box>
    );
  });
};

TypeAheadFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      placeholder: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(PropTypes.object).isRequired,
      selected: PropTypes.arrayOf(PropTypes.string).isRequired,
      onChange: PropTypes.func.isRequired
    })
  ).isRequired
};

export default TypeAheadFilters;
